import { StoredValueChart } from "../charts/StoredValueChart";
import { Controls } from "../controls/Controls";
import { NoTitle } from "./StoredValueTitles";
import { Dummy } from "../charts/Dummy";
import { Header } from "../../../components/Header";

export const factory = (node) => {
  var component = node.getComponent();
  switch (component) {
    case "StoredValue":
      return <StoredValueChart />;
    case "Dummy":
      return <Dummy />;
    case "Header":
      return (
        <Header
          title="Here are the historic price probabilities for the selected horizon
        for the selected ticker according to the Vector Model and Sigma,
        which is an exponentially weighted standard deviation of daily
        returns calculated over the trailing 2 year period."
          label="storedvalue"
        >
          <div>
            Vector and Sigma model based VaR and OaR histories by time horizon.
          </div>
        </Header>
      );
    case "Controls":
      return <Controls />;
    default:
      return null;
  }
};

export const onRenderTabSet = (tabSetNode, refs) => {
  const typeNode = tabSetNode.getType();
  if (typeNode === "tabset") {
    const children = tabSetNode.getChildren();
    children.forEach((child) => {
      const c = child;
      const comp = c.getComponent();
      const rect = c.getRect();
      if (comp) {
        refs.componentSize.current[comp] = {
          width: rect.width,
          height: rect.height,
        };
      }
    });
  }
};

export const layoutModelChange = (model, grefs) => {
  //  console.log(JSON.stringify(model.toJson()));
  grefs.layout.current = JSON.stringify(model.toJson());
};

export const onRenderTab = (node, renderState, componentSize) => {
  var component = node.getComponent();
  switch (component) {
    case "Controls":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Controls"} />
      );
      break;
    default:
    //do nothing
  }
};
